import React from "react";
import Lars from "../Main/avataaars.svg"
import { useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import HTMLRender from "./HTMLRender";
import data from './data';


function ResourceSingle() {
    const [currentItem, updateCurrentItem] = useState();
    const { slug } = useParams();
    console.log(slug)

    useEffect(() => {
    const single = data.filter((item) => item.slug == slug);
    console.log(single)
    updateCurrentItem(single[0])
      }, []);

  return (
    <div className="wrapper billboard">
       <div className="column-lg-12 row center">
        <div className="column column-md-6 column-lg-5">
          <img
            src={Lars}
            className="column-lg-12 hero-image"
            alt="Lars headshot"
          />
        </div>
        <div className="column column-lg-5 column-md-12 bio-container center billboard">
          <code>tl;dr</code>
          <h1>
            Lars Mackenzie creates {" "}
            <span className="highlight">resources</span>, too.{" "}
          </h1>
          <nav><a href="/#about">about</a><a href="/#skills">skills</a><a href="/#contact">contact</a><a href="/photography">photography</a><a href="/resources">resources</a></nav>
        </div>
      </div>

      <div className="row" id="scrolly">
       {currentItem && <div className="column">
        <code>
        <h2>{currentItem.title}</h2>
        </code>
        <div>
            <HTMLRender text={currentItem.content}/>
        </div>
        </div>}
       
   
      </div>
 
    </div>
  );
}
export default ResourceSingle;
